import axios from "axios";

const API_BASE_URL: string | undefined = process.env.API_BASE_URL;
if (!API_BASE_URL) {
  throw new Error(
    "API_BASE_URL is not set — check TARGET_ENV and the matching .env.<TARGET_ENV> file."
  );
}

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: { Accept: "application/json" },
});
